import { render, staticRenderFns } from "./NoticeTemplateManage.vue?vue&type=template&id=73193a67&"
import script from "./NoticeTemplateManage.vue?vue&type=script&lang=js&"
export * from "./NoticeTemplateManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports